<template>
  <div class="c-header-search__block">
    <div class="c-header-search__block-header t-xs-hide t-lg-block">
      <span
        v-if="isDesktop"
        class="c-header-search__block-title "
      >
        {{ selectedContextLongLabel }}
      </span>
    </div>

    <div class="c-header-search__context-selector">
      <template v-for="context in contextOptionsFiltered">
        <button
          :key="'context-button-' + context.value"
          type="button"
          class="c-header-search__context-button"
          :class="{
            'is-active': context.value === selectedContext
          }"
          @click="chooseContext(context.value)"
        >
          {{ context.label_short }}
        </button>
      </template>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import STORE_TYPES_SEARCH from '@/web/store/registered/search'

  import media from '@/tools/mixins/media'
  import { CONTEXTS, IN_USER_STORE_CONTEXTS } from '@/web/components/header/search/context-selector/constants'

  const storeContexts = Object.keys(IN_USER_STORE_CONTEXTS)

  export default {
    mixins: [media],
    props: {
      selectedContext: {
        type: String,
        required: true
      }
    },
    computed: {
      ...mapGetters({
        sellerForSearch: STORE_TYPES_SEARCH.GETTERS.GET_SELLER_FOR_SEARCH
      }),
      selectedContextLongLabel() {
        return CONTEXTS.find((context) => context.value === this.selectedContext).label_long
      },
      isSellerPage() {
        return !!Object.keys(this.sellerForSearch).length
      },
      contextOptionsFiltered() {
        return CONTEXTS
          .filter(context => {
            if (this.isMobile && this.isSellerPage) {
              return storeContexts.indexOf(context.value) > -1
            }
            return storeContexts.indexOf(context.value) === -1
          })
      }
    },
    methods: {
      chooseContext(context) {
        this.$emit('change-context', context)
      }
    }
  }
</script>
